import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function AiScriptPanel() {
  const [prompt, setPrompt] = useState("");
  const [out, setOut] = useState("");
  const [busy, setBusy] = useState(false);

  const streamGenerate = async () => {
    setBusy(true);
    setOut("");
    try {
      const res = await fetch(`${api.defaults.baseURL}/ai/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("core_token")}`,
        },
        body: JSON.stringify({
          prompt,
          context:
            "Generate a real estate script for use in Metro Atlanta. Keep it conversational, under 200 words, and ready to read word-for-word.",
        }),
      });
      await consumeStream(res, setOut);
    } catch {
      toast.error("AI request failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="core-card p-6" data-testid="ai-panel">
      <div className="overline mb-2">Powered by Claude Sonnet 4.5</div>
      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        rows={3}
        placeholder="e.g. Write a follow-up script for a Buckhead seller whose listing expired after 90 days at $1.2M"
        className="w-full p-3 border border-[#d1cece] rounded-lg outline-none focus:border-[#bf858e]"
        data-testid="ai-prompt"
      />
      <button
        onClick={streamGenerate}
        disabled={busy || !prompt}
        className="mt-3 bg-[#050303] text-white pill-btn disabled:opacity-50"
        data-testid="ai-generate-btn"
      >
        {busy ? "Generating…" : "Generate Script"}
      </button>
      {out && (
        <div
          className="mt-5 p-4 bg-[#ffffff] border border-[#d1cece] rounded-lg whitespace-pre-wrap text-sm"
          data-testid="ai-output"
        >
          {out}
        </div>
      )}
    </div>
  );
}

async function consumeStream(res, setOut) {
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value);
    const lines = buf.split("\n");
    buf = lines.pop();
    for (const line of lines) {
      if (!line.startsWith("data: ")) continue;
      const t = line.slice(6);
      if (t === "[DONE]") continue;
      if (t.startsWith("[ERROR]")) {
        toastErr();
        continue;
      }
      setOut((o) => o + t);
    }
  }
}

function toastErr() {
  toast.error("AI error");
}
